import { Form, TreeSelect } from 'antd';
import React from 'react'
import styles from './FieldInput.module.scss'

function TreeSelectField({ input, label, placeholder, meta: { touched, error }, inputProps, treeData = [], handleChange, disabled, tooltip }) {
  return (
    <div className={styles.FieldInput}>
      <Form.Item
        style={{
          flexDirection: 'column',
          width: '100%',
          marginBottom: touched && error && 24 || 20,
        }}
        label={label}
        validateStatus={touched && error && "error" || null}
        help={touched && error || null}
        tooltip={tooltip && {
          title: tooltip,
        }}
      >
        <TreeSelect
          showSearch
          value={input.value == 0 ? '' : input.value}
          placeholder={placeholder}
          treeDefaultExpandAll
          {...inputProps}
          disabled={disabled}
          onChange={(e) => {
            if (handleChange) {
              handleChange(e);
            }
            input.onChange(e);
          }}
          treeData={treeData}
        />
      </Form.Item>
      {/* {touched && ((error && <span style={{ color: '#f04d4d', fontSize: 14 }}>{error}</span>))} */}
    </div>
  )
}

export default TreeSelectField